import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState, useContext } from "react";
import Lottie from "lottie-react";
import ReactPlayer from "react-player";
import animation from "../../../components/GainfulLoading/icons-animation.json";
import { apiGetRDVideoInfo } from "Root/api/apiCheckout";
import { CheckoutContext } from "Root/checkout/CheckoutRoutes";
import posthog from 'posthog-js';
import Logo from "Images/profile/squareLogo.svg";
import nameLogo from "Images/checkout/name_logo.svg";
import styles from "./styles.module.css";
function CheckoutVideosPage() {
    const [videoURL, setVideoURL] = useState("");
    const [dietitianName, setDietitianName] = useState("");
    const { discountBanner } = useContext(CheckoutContext);
    const fetchVideoData = async () => {
        try {
            const data = await apiGetRDVideoInfo();
            setVideoURL(data.videoUrl);
            setDietitianName(data.dietitianName);
        }
        catch (e) {
            console.log(e);
        }
    };
    useEffect(() => {
        fetchVideoData();
        posthog?.capture('$pageview');
    }, []);
    return (_jsxs(_Fragment, { children: [_jsxs("header", { className: styles.header, children: [_jsx("a", { href: "/", children: _jsx("img", { className: styles.logo, src: Logo, alt: "logo_banner" }) }), _jsx("a", { className: styles.logoname, href: "/", children: _jsx("img", { src: nameLogo, alt: "logo" }) })] }), _jsx("main", { className: styles.maincontainer, children: _jsx("div", { className: styles.videocontainer, children: videoURL.length !== 0 && dietitianName.length !== 0 ? (_jsxs(_Fragment, { children: [_jsxs("h3", { className: styles.videowelcome, children: ["Welcome from ", dietitianName, ", ", _jsx("br", {}), " Your Personal Dietitian"] }), _jsx("div", { className: styles.videowrapper, children: _jsx(ReactPlayer, { width: 520, className: styles.video, url: videoURL, playing: true, playsinline: true, config: {
                                        vimeo: {
                                            playerOptions: {
                                                controls: true,
                                            },
                                        },
                                    } }) }), _jsxs("h4", { className: styles.videosale, children: ["Get unlimited access to ", dietitianName, " with your Gainful subscription."] })] })) : (_jsx("div", { className: styles.loadingcontainer, children: _jsx(Lottie, { animationData: animation, autoPlay: true }) })) }) }), _jsxs("footer", { className: styles.footer, children: [_jsx("a", { href: "/checkout/", className: styles.footerbutton, children: "Continue to Checkout" }), discountBanner && _jsx("div", { className: styles.discountBanner, children: discountBanner })] })] }));
}
export default CheckoutVideosPage;
